﻿const defaultState = {
    fetchAchievementsFailed: false,
    newAchievements: [],
}

export function achievementsData(state = defaultState, action) {
    switch (action.type) {
        case 'ACHIEVEMENTS_FETCH':
            return { ...state, ...action.data };
        case 'NEW_ACHIEVEMENTS_FETCH':
            return { ...state, ...action.data };
        case 'ACHIEVEMENTS_FETCH_FAILED':
            return { ...state, fetchAchievementsFailed: action.data };
        default:
            return state;
    }
}

export function newAchievementsData(state = defaultState, action) {
    switch (action.type) {
        case 'NEW_ACHIEVEMENTS_FETCH':
            return { ...state, newAchievements: action.data };
        case 'ACHIEVEMENTS_FETCH_FAILED':
            return { ...state, fetchAchievementsFailed: action.data };
        default:
            return state;
    }
}